import { Component, OnInit, ViewEncapsulation, AfterViewInit, EventEmitter } from '@angular/core';
import { Helpers } from '../../../helpers';
import { RightAsideList } from '../../../_classes/rightaside';

declare let mLayout: any;
declare let $: any;

@Component({
    standalone: false,
    selector: "app-right-aside-nav",
    templateUrl: "./right-aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class RightAsideNavComponent implements OnInit, AfterViewInit {

    visible: boolean;
    contents: RightAsideList[];
    link: string;

    constructor() {
        localStorage.removeItem('rightAside');
    }
    ngOnInit() {
        $('[data-toggle="m-tooltip"]').tooltip('dispose');
        let rightAside = JSON.parse(localStorage.getItem('rightAside'));
        if (rightAside) {
            this.visible = rightAside.visible;
            this.contents = rightAside.contents;
            this.link = this.contents[0].link;
        }
        else this.visible = false;
    }

    ngAfterViewInit() {
        $('[data-toggle="m-tooltip"]').tooltip();
    }

}
